import { render } from "./IPIcon.vue?vue&type=template&id=6f600846&scoped=true"
import script from "./IPIcon.vue?vue&type=script&lang=js"
export * from "./IPIcon.vue?vue&type=script&lang=js"

import "./IPIcon.vue?vue&type=style&index=0&id=6f600846&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f600846"]])

export default __exports__